import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { BusinessProviderPropType } from './types/business';
import { getBusinessSchemaType } from './utils/business';
import { markdownToPlainText } from './utils/markdown';
import { Helmet } from '../../../modules/foundation/components/HelmetProvider';
var defaultProps = {
  description: ''
};
export default function ServiceCategorySchema(_ref) {
  var businessName = _ref.businessName,
    businessCategories = _ref.businessCategories,
    name = _ref.name,
    description = _ref.description;
  var data = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: name,
    name: name,
    description: markdownToPlainText(description),
    provider: {
      '@type': getBusinessSchemaType(businessCategories),
      name: businessName
    }
  };
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
}
ServiceCategorySchema.defaultProps = defaultProps;